// #ux-redesign-start: Badge primitive (Paso 2)
// Badge soft (background tinted + text del color), no solid pesado.
// Reemplaza el uso de Reactstrap Badge ad-hoc en ~30+ componentes.
//
// PORTABILIDAD: trasplantable a Web-Patients.
//
// USO:
//   <Badge variant="success">Endbefund</Badge>
//   <Badge variant="warning">Offen</Badge>
//   <Badge variant="priority" dot>Eilig</Badge>   // priority = naranja, foco de atencion
//   <Badge variant="neutral" size="sm">Entwurf</Badge>
//
// Variants:
//   - success:  verde (estado positivo/completado)
//   - warning:  amber (estado pendiente)
//   - danger:   rojo
//   - info:     azul (estado neutral informativo, ej. "TP")
//   - priority: naranja marca (alta prioridad / atencion del medico)
//   - neutral:  gris (estado bajo, ej. "Entwurf")
//
// Sizes: sm (20px) / md (24px, default)
// ─────────────────────────────────────────────────────────────────────────────

import React from 'react';
import PropTypes from 'prop-types';

const Badge = ({
  variant = 'neutral',
  size = 'md',
  dot = false,
  className = '',
  children,
  ...rest
}) => {
  const classes = [
    'ds-badge',
    `ds-badge--${variant}`,
    `ds-badge--${size}`,
    dot ? 'ds-badge--with-dot' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <span className={classes} {...rest}>
      {dot && <span className="ds-badge__dot" aria-hidden="true" />}
      <span className="ds-badge__label">{children}</span>
    </span>
  );
};

Badge.propTypes = {
  variant: PropTypes.oneOf(['success', 'warning', 'danger', 'info', 'priority', 'neutral']),
  size: PropTypes.oneOf(['sm', 'md']),
  dot: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Badge;
// #ux-redesign-end
